module.exports = __webpack_public_path__ + "static/media/book_shadow_icon.16569cc8.svg";